export default __webpack_public_path__ + "static/media/cliente05_color.28d19552.png";